//@flow
import { PNR_IMPORT_TYPES } from '../../constants/global';

export const paymentIsManualyImported = (importType) => {
  return importType === PNR_IMPORT_TYPES.manualImport;
};
